import React, { useEffect, useState, useCallback, useRef, useMemo, memo } from 'react';
import { AgGridReact } from 'ag-grid-react';

const CommonGrid = ({ rowDatas, columnDefss }) => {


    useEffect(() => {
    }, []);

    const [columnDefs, setColumnDefs] = useState(columnDefss);
    const [rowData, setRowData] = useState(rowDatas);
    const [gridApi, setGridApi] = useState(null);

    const onGridReady = useCallback((params) => {
        setGridApi(params.api);
    }, []);


    return (<div>
        <div className="ag-theme-material" style={{ height: "600px", width: "100%" }}>
            <AgGridReact
                columnDefs={columnDefs}
                rowData={rowData}
                onGridReady={onGridReady}
            />

        </div>
    </div>);

}

export default CommonGrid;


// WEBPACK FOOTER //
// ./src/scenes/Dashboard/common-grid.js